import type {
  EvalCheckVerdict,
  EvalFindingResolution,
  EvalFindingSeverity,
  EvalRunStatus,
  EvalStepStatus,
} from './types';

export const POLL_INTERVAL_MS = 3_000;

/** Labels for the run header dropdown + status chips. */
export const RUN_STATUS_LABEL: Record<EvalRunStatus, string> = {
  PENDING: 'Queued',
  RUNNING: 'Running',
  SUCCEEDED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
};

export const STEP_STATUS_LABEL: Record<EvalStepStatus, string> = {
  PENDING: 'Queued',
  RUNNING: 'Running',
  SUCCEEDED: 'Done',
  FAILED: 'Failed',
};

export const SEVERITY_LABEL: Record<EvalFindingSeverity, string> = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  INFO: 'Info',
};

/** Lifecycle badge labels on a resolved / dismissed finding card. */
export const RESOLUTION_LABEL: Record<EvalFindingResolution, string> = {
  RESOLVED: 'Resolved',
  DISMISSED: 'Dismissed',
};

/** Verdict labels for the checklist register's group headers and count strip. */
export const CHECK_VERDICT_LABEL: Record<EvalCheckVerdict, string> = {
  PASS: 'Passed',
  FAIL: 'Failed',
  NOT_EVIDENCED: 'Not evidenced',
  NOT_APPLICABLE: 'Not applicable',
};

/**
 * What each verdict means, as a tooltip on the group header. NOT_EVIDENCED vs
 * NOT_APPLICABLE is the distinction reviewers most need spelled out: one is a
 * gap in the document, the other is a check that simply doesn't apply.
 */
export const CHECK_VERDICT_HINT: Record<EvalCheckVerdict, string> = {
  PASS: 'The contract satisfies this check.',
  FAIL: 'The contract does not satisfy this check.',
  NOT_EVIDENCED: 'The check applies, but the contract does not evidence it either way.',
  NOT_APPLICABLE: "This check's condition is not triggered by this contract.",
};
